import * as React from "react";
import Box from "@mui/material/Box";
import ViewClientAccPD from "./ViewClientAccPD";


const ClientAccPDHome = () => {
  return (
    <Box sx={{ width: "100%" }}>
      <ViewClientAccPD />
    </Box>
  );
};

export default ClientAccPDHome;